import { AppPlugins, pluginRoutePrefix } from 'app/constants'
import { Route } from 'core/plugins/route'

const defaultParams = {
  plugin: AppPlugins.OpenCloud,
}

const metadata = {
  showGlobalFilters: true,
}

export const opencloudRoutes = {
  opencloud: {
    home: Route.register({
      url: `${pluginRoutePrefix}/home`,
      name: 'Home',
      id: 'opencloudHome',
      breadcrumbs: new Map([['home', 'opencloudHome']]),
      metadata,
      defaultParams,
    }),
    adminConsole: Route.register<{
      region: string
    }>({
      url: `${pluginRoutePrefix}/:region/admin-console`,
      name: 'Admin Console',
      id: 'opencloudAdminConsole',
      breadcrumbs: new Map([
        ['home', 'opencloudHome'],
        [':region', 'opencloudAdminConsole'],
        ['admin-console', 'opencloudAdminConsole'],
      ]),
      metadata,
      defaultParams,
    }),
    alerts: Route.register<{ region: string }>({
      url: `${pluginRoutePrefix}/:region/alerts`,
      name: 'Alerts',
      id: 'opencloudAlerts',
      breadcrumbs: new Map([
        ['home', 'opencloudHome'],
        [':region', 'opencloudAdminConsole'],
        ['alerts', 'opencloudAlerts'],
      ]),
      metadata,
      defaultParams,
    }),
    kubernetesDashboard: Route.register({
      url: `${pluginRoutePrefix}/kubernetes/clusters`,
      name: 'Home',
      id: 'k8sDashboard',
      breadcrumbs: new Map([['dashboard', 'k8sDashboard']]),
      metadata,
      defaultParams,
    }),
    databaseClusters: {
      list: Route.register<{}>({
        url: `${pluginRoutePrefix}/database-clusters`,
        name: 'DatabaseClusters:List',
        id: 'databaseClustersDashboard',
        breadcrumbs: new Map([['dashboard', 'databaseClustersDashboard']]),
        metadata,
        defaultParams,
      }),
    },
  },
}
